import { render, staticRenderFns } from "./risorse.vue?vue&type=template&id=f14c9b64&scoped=true&"
import script from "./risorse.vue?vue&type=script&lang=js&"
export * from "./risorse.vue?vue&type=script&lang=js&"
import style0 from "./risorse.vue?vue&type=style&index=0&id=f14c9b64&scoped=true&lang=css&"
import style1 from "./risorse.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14c9b64",
  null
  
)

export default component.exports